export default __webpack_public_path__ + "static/media/wrench-1.6e4ae4c9.png";